import { render, staticRenderFns } from "./ModalEditTbs.vue?vue&type=template&id=3168c3b5&scoped=true&"
import script from "./ModalEditTbs.vue?vue&type=script&lang=js&"
export * from "./ModalEditTbs.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditTbs.vue?vue&type=style&index=0&id=3168c3b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3168c3b5",
  null
  
)

export default component.exports